<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="alterarApoiadoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Apoiado</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!marcacao" />

                        <div v-else>
                            <div class="alert alert-info">
                                <div class="lead">{{ marcacao.nome_paciente }}</div>
                                <div>#{{ marcacao.id_atendimento }}
                                    <span v-if="marcacao.st_id_externo">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ marcacao.st_id_externo }}
                                    </span>
                                </div>
                            </div>

                            <div class="mt-3" v-if="marcacao.atendimento">

                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Apoiado..."
                                            icon="fa-solid fa-house-signal fa-fw"
                                            sizing="sm"
                                            type="autocomplete"
                                            service="apoiados.index"
                                            optionsMode="aql"
                                            optionsName="apoiados.index"
                                            :optionsParm="{ id_atendimento: marcacao.atendimento.id_atendimento }"
                                            v-model="marcacao.atendimento.apoiado" />
                                    </div>

                                </div>

                                <div class="form-row mt-2">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Origem..."
                                            icon="fa-solid fa-location-dot fa-fw"
                                            sizing="sm"
                                            type="autocomplete"
                                            service="apoiado_origens.index"
                                            optionsMode="aql"
                                            optionsName="apoiados.index"
                                            :optionsParm="{ id_apoiado: marcacao.atendimento.apoiado ? marcacao.atendimento.apoiado.id_apoiado : -1 }"
                                            :edicao="( marcacao.atendimento.apoiado && marcacao.atendimento.apoiado.origens_count > 0 ) ? true : false"
                                            v-model="marcacao.atendimento.apoiado_origem" />
                                    </div>
                                </div>

                                <br><br><br><br><br><br><br><br><br><br><br><br>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            lista: null, 
            marcacao: null,
            search: "",  
            guia: null, 
            validate: false, 
            solics: null, 
        }
    },

    components: { 
        AzEmptyState,
        AzSubmit, 
        AzInput, 
    },

    computed: { 
        exibicao: function () { 
            if ( !this.lista )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.lista.filter (item => !this.search || reg.test(JSON.stringify(item)));
        }
    },

    methods: { 
        alterar(marcacao) { 
            this.marcacao = null;
            this.validate = false;
            this.solics = null;
            
            $('#alterarApoiadoModal').modal('show');

            this.$util.load(this, { 
                service: 'marcacoes', 
                func: 'show',
                parms: {
                    id: marcacao.id_marcacao,
                    com_apoiado: true, 
                },
                loadTo: res => {
                    this.marcacao = res;
                }
            });
        },

        atualizar() { 

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'alterar_apoiado',
                dados: { 
                    ...this.marcacao, 
                },
                toast: true,
                modal: 'alterarApoiadoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
            
        }
    }

}
</script>